/* sm-kenburns.js
   Custom showcase slider (snippets/sm-kenburns.liquid) and its dots and
   caption (snippets/sm-kb-controls.liquid). A slider and its controls are
   linked by data-sm-kb-group (the product id), so they work on product
   pages and inside panels loaded later on /pages/custom.
   SMKB.mountAll(scope) mounts anything inside scope; each root mounts once.
   A slider whose root leaves the page stops its own timer. */
(function () {
  if (window.SMKB) return;

  var SLIDE_DURATION = 5000;
  var KB_ANIMS       = ['sm-kb-anim-1', 'sm-kb-anim-2', 'sm-kb-anim-3', 'sm-kb-anim-4'];

  var sliders = {};   // group -> slider instance
  var waiting = {};   // group -> [controls roots waiting for their slider]

  function groupOf(root) {
    return root.getAttribute('data-sm-kb-group') || 'default';
  }

  function getRandomKb() {
    return KB_ANIMS[Math.floor(Math.random() * KB_ANIMS.length)];
  }

  function mountSlider(root) {
    if (!root || root.getAttribute('data-sm-kb-mounted') === '1') return;
    root.setAttribute('data-sm-kb-mounted', '1');

    (function () {
      var slideEls = root.querySelectorAll('.sm-kb-slides .sm-kb-slide');
      if (!slideEls.length) return;

      var slides     = Array.prototype.slice.call(slideEls);
      var current    = 0;
      var autoPaused = false;
      var listeners  = [];
      var timer      = null;

      // Shuffle slides in place
      slides.sort(function () { return Math.random() - 0.5; });
      slides.forEach(function (slide, i) {
        slide.parentNode.appendChild(slide);
        slide.classList.remove('sm-kb-slide-active');
        if (i === 0) slide.classList.add('sm-kb-slide-active');
      });

      slides[0].classList.add(getRandomKb());

      // Shuffle runs before the first paint, then the slider is revealed,
      // so guests never see one photo flash and switch to another.
      var firstImg = slides[0].querySelector('img');
      if (firstImg) firstImg.loading = 'eager';
      root.setAttribute('data-sm-kb-ready', '1');

      function goToSlide(index) {
        if (!slides.length) return;
        slides[current].classList.remove('sm-kb-slide-active');
        KB_ANIMS.forEach(function (c) { slides[current].classList.remove(c); });
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('sm-kb-slide-active');
        slides[current].classList.add(getRandomKb());
        listeners.forEach(function (fn) { fn(current); });
      }

      var inst = {
        root:      root,
        getSlides: function () { return slides; },
        getCurrent: function () { return current; },
        goTo:      function (i) { autoPaused = true; goToSlide(i); },
        onChange:  function (fn) { listeners.push(fn); }
      };

      var group = groupOf(root);
      sliders[group] = inst;

      if (slides.length > 1) {
        timer = setInterval(function () {
          if (!root.isConnected) {
            clearInterval(timer);
            if (sliders[group] === inst) delete sliders[group];
            return;
          }
          if (!autoPaused) goToSlide(current + 1);
        }, SLIDE_DURATION);
      }

      (waiting[group] || []).forEach(function (ctrl) { attachControls(ctrl, inst); });
      delete waiting[group];
    })();
  }

  function attachControls(root, inst) {
    var dotsWrap = root.querySelector('.sm-kbc-dots');
    var cap      = root.querySelector('.sm-kbc-caption');
    var slides   = inst.getSlides();
    var dots     = [];

    function setCaption(index) {
      if (!cap || !slides[index]) return;
      cap.style.opacity = '0';
      setTimeout(function () {
        cap.textContent = slides[index].getAttribute('data-caption') || '';
        cap.style.opacity = '1';
      }, 300);
    }

    function updateDots(index) {
      dots.forEach(function (d) { d.classList.remove('sm-kbc-dot-active'); });
      if (dots[index]) dots[index].classList.add('sm-kbc-dot-active');
      setCaption(index);
    }

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'sm-kbc-dot' + (i === inst.getCurrent() ? ' sm-kbc-dot-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        inst.goTo(i);
        updateDots(i);
      });
      if (dotsWrap) dotsWrap.appendChild(dot);
      dots.push(dot);
    });

    if (slides.length <= 1 && dotsWrap) dotsWrap.style.display = 'none';

    setCaption(inst.getCurrent());
    inst.onChange(updateDots);
  }

  function mountControls(root) {
    if (!root || root.getAttribute('data-sm-kbc-mounted') === '1') return;
    root.setAttribute('data-sm-kbc-mounted', '1');
    var group = groupOf(root);
    var inst  = sliders[group];
    if (inst && inst.root.isConnected) {
      attachControls(root, inst);
    } else {
      (waiting[group] = waiting[group] || []).push(root);
    }
  }

  function mountAll(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-sm-kb]'), mountSlider);
    Array.prototype.forEach.call(s.querySelectorAll('[data-sm-kbc]'), mountControls);
  }

  window.SMKB = { mountAll: mountAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
  } else {
    mountAll(document);
  }

})();
